import React from 'react';
import { Link } from 'react-router-dom';
import './LandingFooter.css';

const LandingFooter = () => {
  return (
    <footer className="lf-footer">
      <div className="lf-footer-inner">
        <div className="lf-footer-grid">
          {/* Brand */}
          <div className="lf-footer-brand">
            <Link to="/" className="lf-footer-logo">
              <img src="/favicon.png" alt="Hisab OK Hai" />
              <span>Hisab OK Hai</span>
            </Link>
            <p className="lf-footer-tagline">Roz ka kharcha, bina tension</p>
            <div className="lf-footer-badge">
              <span>Android App Coming Soon</span>
            </div>
          </div>

          {/* Product */}
          <div className="lf-footer-col">
            <h4>Product</h4>
            <ul>
              <li><Link to="/#features">Features</Link></li>
              <li><Link to="/expense-tracker-india">Expense Tracker</Link></li>
              <li><Link to="/daily-expense-tracker">Daily Tracking</Link></li>
              <li><Link to="/budget-planner-india">Budget Planner</Link></li>
            </ul>
          </div>

          {/* Company */}
          <div className="lf-footer-col">
            <h4>Company</h4>
            <ul>
              <li><Link to="/udhari-management-app">How It Works</Link></li>
              <li><Link to="/help">Help Center</Link></li>
              <li><a href="mailto:support@hisabokhai.in">Contact</a></li>
              <li><Link to="/">About</Link></li>
            </ul>
          </div>

          {/* Legal & Links */}
          <div className="lf-footer-col">
            <h4>Account</h4>
            <ul>
              <li><Link to="/login">Login</Link></li>
              <li><Link to="/signup">Sign Up Free</Link></li>
            </ul>
            <h4 className="lf-footer-col-sub">Legal</h4>
            <ul>
              <li><Link to="/">Privacy Policy</Link></li>
              <li><Link to="/">Terms of Service</Link></li>
            </ul>
          </div>
        </div>

        <div className="lf-footer-bottom">
          <p>&copy; {new Date().getFullYear()} Hisab OK Hai by INDIATECH247. All rights reserved.</p>
          <div className="lf-footer-bottom-links">
            <Link to="/">Home</Link>
            <Link to="/login">Login</Link>
            <Link to="/signup">Sign Up</Link>
            <Link to="/help">Help</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default LandingFooter;
